import { gql } from 'graphql-request';

const instances = gql`
  instances {
      url
      width
      height
  }
`;

const PrimaryVisuals = gql`
  video {
    url
    caption
    background
    credit {
      name
      url
    }
  }
  social {
    preferredAspectRatio {
      slug
      ${instances}
    }
    aspect_ratios: aspectRatios {
      thumbnail {
        ${instances}
      }
      square {
        ${instances}
      }
      widescreen {
        ${instances}
      }
      uncropped {
        ${instances}
      }
      normal {
        ${instances}
      }
    }
    fallback
    shortCaption
    credit {
      name
      url
    }
  }
  lead {
    preferredAspectRatio {
      ${instances}
      slug
    }
    aspect_ratios: aspectRatios {
      thumbnail {
        ${instances}
      }
      square {
        ${instances}
      }
      widescreen {
        ${instances}
      }
      uncropped {
        ${instances}
      }
      normal {
        ${instances}
      }
    }
    fallback
    longCaption
    shortCaption
    credit {
      name
      url
    }
  }
  thumbnail {
    type
    preferredAspectRatio {
      ${instances}
      slug
    }
    aspect_ratios: aspectRatios {
      thumbnail {
        ${instances}
      }
      square {
        ${instances}
      }
      widescreen {
        ${instances}
      }
      uncropped {
        ${instances}
      }
      normal {
        ${instances}
      }
    }
    fallback
    shortCaption
    credit {
      name
      url
    }
  }
`;

export default PrimaryVisuals;
